import React from "react";
import { useLocation } from 'react-router';

import { ROUTE_PAGE_WIZARD } from "../../../routers/routes";
import HeaderLanding from "../landing/HeaderLanding";
import HeaderWizard from "../wizard/HeaderWizard";
import HeaderFastLogin from "./HeaderFastLogin";

const Header = () => {
  const { pathname } = useLocation();
  if (pathname === ROUTE_PAGE_WIZARD.path) {
    return <HeaderWizard />;
  }

  if (pathname === '/loans/application/fast-login') {
    return <HeaderFastLogin />;
  }

  return <HeaderLanding />;
}

export default Header;
